import { apiRequest, apiGETRequest } from "../utility/Utility";

export const validateUser = async (email) => {
  try {
    const response = await apiRequest({
      endpoint: "/api/signin",
      payload: { email },
      returnRaw: true
    });
    return response;
  } catch (error) {
    // console.error("Exception occurred while validating user: ", error.message);
    return null; // Handle the error or return a default value
  }
};

export const verifyOTPAndFetchUserInfo = async (
  otp,
  emailId,
  reCaptchaToken
) => {
  try {
    const response = await apiRequest({
      endpoint: "/api/verifyOtp",
      payload: {
        otp,
        email: emailId,
        reCaptchaToken: reCaptchaToken,
      },
      returnRaw: true
    });
    // if (response.data.Autheticated === 1)
    //   return {
    //     status: 0,
    //     title: "OTP Verified",
    //     message: "OTP verified and UserInfo fetched",
    //     data: response.data,
    //   };
    switch (response.data.Autheticated) {
      case 1:
        return {
          status: 0,
          title: "OTP Verified",
          message: "OTP verified and UserInfo fetched",
          data: response.data,
        };
      case -1:
        return {
          status: 1,
          title: "User account is inactive",
          message: "User account is inactive",
        };
      case 0:
        return {
          status: 1,
          title: "Invalid OTP",
          message: "Please enter a valid OTP",
        };
      case 2:
        return {
          status: 2,
          title: "Unusual Sign-In Activity",
          message:
            "If you continue to receive this message and are unable to sign in, please contact our service team at pfas@owp.csus.edu or 916-278-4483.",
        };
        case -2:
          return {
            status: -2,
            title: "Exception occured",
            message: "Exception occured while verifying OTP: Contact Adminstrator",
          };
      default:
        return {
          status: 1,
          title: "Exception occured",
          message: "Exception occured while verifying OTP",
        };
    }
    // return {
    //   status: 1,
    //   title:
    //     response.data.Autheticated === -1
    //       ? "User account is inactive"
    //       : "Invalid OTP",
    //   message:
    //     response.data.Autheticated === -1
    //       ? "User account is inactive"
    //       : "Please enter a valid OTP",
    // };
  } catch (error) {
    //console.error("Exception occured while verifying OTP: ", error.message);
    const { title = null, message = null } = error?.response?.data;
    return {
      status: 1,
      title:  title ?? "Exception occured",
      message: "Exception occured while verifying OTP: " + message ?? error.message,
    };
  }
};

export const authenticateUser = async () => {
  try {
    const response = await apiGETRequest({
      endpoint: "/api/authenticate"
    });
    return response;
  } catch (error) {
    return {
      status: 0
    };
  }
};
